<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('reportStudentClassAttendance.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('reportStudentClassAttendance.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-4">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>
                    {{ $t('reportStudentClassAttendance.criteria') }}
                  </legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('reportStudentClassAttendance.acYear')
                      }}</label>
                      <a-select
                        style="width: 100%"
                        v-model.number="model.ac_year_id"
                        :options="ac_year_list"
                        @change="acYearChange"
                      ></a-select>
                      <div class="validate" v-if="errors.has('ac_year_id')">
                        {{ errors.first('ac_year_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('reportStudentClassAttendance.subProgram')
                      }}</label>
                      <a-select
                        style="width: 100%"
                        v-model.number="model.acps_id"
                        :options="sub_programs"
                        :show-search="true"
                        :filter-option="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        @change="onSubChange"
                        :disabled="!model.ac_year_id"
                      ></a-select>
                      <div class="validate" v-if="errors.has('acps_id')">
                        {{ errors.first('acps_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('reportStudentClassAttendance.acTerm')
                      }}</label>
                      <a-select
                        style="width: 100%"
                        v-model.number="model.ac_term_id"
                        :options="ac_terms"
                        :show-search="true"
                        :filter-option="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        @change="acTermChange"
                      ></a-select>
                      <div class="validate" v-if="errors.has('ac_term_id')">
                        {{ errors.first('ac_term_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('reportStudentClassAttendance.classOperation')
                      }}</label>
                      <a-select
                        style="width: 100%"
                        v-model.number="model.class_id"
                        :options="class_options"
                        :show-search="true"
                        :filter-option="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                      ></a-select>
                      <div class="validate" v-if="errors.has('class_id')">
                        {{ errors.first('class_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
										<div class="col-md-12">
											<label class="required">{{
												$t('reportAttendanceByStudent.batch')
											}}</label>
											<input type="number" v-model="model.promotion" class="form-control kh-font only-border-bottom" />
										</div>
									</div>
                  <div class="row">
                    <div class="col-md-12 text-right">
                      <ts-button
                        class="btn-block"
                        outline
                        color="success"
                        @click.prevent="exportExcel"
                        :waiting="exporting"
                        >{{ $t('excel') }}</ts-button
                      >
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-8">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>
                  {{ $t('reportStudentClassAttendance.preview') }}
                </legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'
import moment from 'moment'
import { debounce } from 'lodash'

export default {
  name: 'reportStudentClassAttendance',
  data() {
    return {
      loading: false,
      waiting: false,
      exporting: false,
      src: '',
      errors: new Errors(),
      sub_programs: [],
      ac_terms: [],
      ac_year_list: [],
      class_options: [],
      headers: [],
      columnLists: [],
      model: {
        acps_id: null,
        ac_term_id: null,
        ac_year_id: null,
        class_id: null,
        promotion: null
      }
    }
  },
  created() {
    this.fetchData()
    this.getHeader()
  },
  methods: {
    ...mapActions('reportAcademic', [
      'classAttendance',
      'getSubProgram',
      'getTerm',
      'getYear',
      'getClass'
    ]),
    moment,
    async fetchData() {
      this.loading = true
      await this.getYear()
        .then(response => {
          this.ac_year_list = response.data.map(el => ({
            value: el.ac_year_id,
            label:
              el.ac_year +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                ? ' ( History ) '
                : ' ( Next ) ')
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
      await this.getSubProgram()
        .then(response => {
          this.sub_programs = response.data.map(el => ({
            value: el.acps_id,
            label: el.acps_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getHeader() {
      this.loading = true
      this.errors = new Errors()
      this.$store
        .dispatch('reportAcademic/getHeader', this.model)
        .then(response => {
          this.headers = response['columnHeaders']
          this.columnLists = response['columnLists']
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    onSubChange(acps_id) {
      this.model.ac_term_id = null
      this.model.class_id = null
      this.loading = true
      this.getTerm({
        filter: {
          acps_id: acps_id,
          ac_year_id: this.model.ac_year_id
        }
      })
        .then(response => {
          this.ac_terms = response.data.map(el => ({
            value: el.ac_term_id,
            label:
              el.term_name +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                ? ' ( History ) '
                : ' ( Next ) ')
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    acYearChange() {
      this.model.acps_id = null
      this.model.ac_term_id = null
      this.model.class_id = null
    },
    acTermChange(ac_term_id) {
      this.loading = true
      this.getClass({
        filter: {
          ac_term_id: ac_term_id
        }
      })
        .then(response => {
          this.class_options = response.data
            .filter(c => c.weekday_type_id != null)
            .map(el => ({
              value: el.class_id,
              label: el.class_name + ' (' + el.weekday_type.weekday_type + ')'
            }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    exportExcel() {
      this.exporting = true
      this.errors = new Errors()

      this.$store
        .dispatch('reportAcademic/studentClassAttendanceExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    }
  },
  watch: {
    model: debounce(function(value) {
      this.getHeader()
    }, 500)
  }
}
</script>
